import { Component, computed, inject, input } from '@angular/core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IconService } from '@unity/services/icon.service';
import { LinkSharedComponent, LinkVariant } from '@unity/shared/composed/link-shared/link-shared.component';
import { UnityRouteUrlTrees } from '@unity/utils/types';

@Component({
  selector: 'unity-link-mailto-shared',
  standalone: true,
  imports: [IconsModule, LinkSharedComponent],
  templateUrl: './link-mailto-shared.component.html',
  styleUrl: './link-mailto-shared.component.scss',
})
export class LinkMailtoSharedComponent {
  private readonly iconService = inject(IconService);

  protected readonly envelopeIcon = this.iconService.envelopeIcon;

  public readonly $emailAddress = input.required<string>({ alias: 'emailAddress' });
  public readonly $variants = input<LinkVariant[]>([], { alias: 'variants' });

  protected readonly $link = computed(() => `mailto:${this.$emailAddress()}` as unknown as UnityRouteUrlTrees);
}
